/**
 * @description qaアコーディオン
 */

import { isSumaho } from '../common/isSumaho';
import { isTablet } from '../common/isTablet';

export const setAccordion = () => {
  $('.qa').find('.answer').hide();
  $('.qa').on('click', function () {
    const box = $(this).find('.answer');
    $(box).slideToggle();
    if ($(this).hasClass('close')) {
      $(this).removeClass('close');
    } else {
      $(this).addClass('close');
    }
  });

  $('.js-spAccordion-trigger').on('click', function () {
    if (isSumaho() || isTablet()) {
      $(this).toggleClass('on');
    }
  });
};
